import React from "react";
import { GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ensureFullTvSeriesContentDetails } from "../../../../../common/types/ContentDetails";
import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { OnPremAssetDetails } from "../../OnPremAssetDetails";
import { OnPremTvSeriesVersionInfo } from "./OnPremTvSeriesVersionInfo";

type OnPremTvSeriesContentSectionProps = {
    assetDetails: OnPremAssetDetails;
};

export const OnPremTvSeriesContentSection: React.FunctionComponent<OnPremTvSeriesContentSectionProps> = ({
    assetDetails
}) => {
    ensureFullTvSeriesContentDetails(assetDetails.content);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={assetDetails.content.tvSeries.name}
                        testId="tvSeries-name-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[assetDetails.content.subtype]}
                        testId="tvSeries-content-type-field"
                    />
                    <LabeledText
                        label="Season"
                        value={assetDetails.content.season.name}
                        testId="tvSeries-season-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Episode"
                        value={assetDetails.content.episode.name}
                        testId="tvSeries-episode-field"
                        textTooltip
                    />
                </GridColumn>
                <GridColumn sm={6}>
                    <OnPremTvSeriesVersionInfo
                        tvSeriesId={assetDetails.content.tvSeries.id}
                        versionIds={assetDetails.content.versionSummary.ids}
                        episodeId={assetDetails.content.episode.id}
                        seasonId={assetDetails.content.season.id}
                    />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
